export { default as Img200 } from './processed/200/X-Men-Days-of-Future-Past.jpg';
export { default as Img400 } from './processed/400/X-Men-Days-of-Future-Past.jpg';
export { default as Imgthumb } from './processed/thumb/X-Men-Days-of-Future-Past.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/X-Men-Days-of-Future-Past.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/X-Men-Days-of-Future-Past.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      71,
      71,
      184
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      28,
      28,
      72
    ],
    "_population": 2,
    "_hsl": [
      0.6666666666666666,
      0.44,
      0.19607843137254902
    ]
  },
  "Muted": {
    "_rgb": [
      112,
      115,
      166
    ],
    "_population": 2676,
    "_hsl": [
      0.6574074074074073,
      0.23275862068965517,
      0.5450980392156863
    ]
  },
  "LightMuted": {
    "_rgb": [
      193,
      173,
      177
    ],
    "_population": 2518,
    "_hsl": [
      0.9666666666666668,
      0.13888888888888878,
      0.7176470588235294
    ]
  },
  "DarkMuted": {
    "_rgb": [
      47,
      40,
      78
    ],
    "_population": 2463,
    "_hsl": [
      0.6973684210526315,
      0.3220338983050848,
      0.23137254901960785
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/X-Men-Days-of-Future-Past.js